import { __awaiter, __generator, __read } from "tslib";
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { OfficeWorkload } from '@office-start/officehome-types';
import { logError } from '@office-start/telemetry-service';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import { useEffect, useState } from 'react';
import { getFreshAccessToken } from '../util/getFreshAccessToken';
export var usePrefetchAccessToken = function () {
    var _a, _b;
    var componentContext = useOfficeComponentContext().data;
    var userEntitlements = (_a = useUserEntitlements().data) === null || _a === void 0 ? void 0 : _a.result;
    var featureGates = useFeatureGates().data;
    var usePrefetchAccessTokenEnabled = ((_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.usePrefetchAccessTokenGates) === null || _b === void 0 ? void 0 : _b.usePrefetchAccessTokenEnabled) &&
        (componentContext === null || componentContext === void 0 ? void 0 : componentContext.workload) === OfficeWorkload.OfficeHomeReact;
    var _c = __read(useState(), 2), prefetchedToken = _c[0], setPrefetchedToken = _c[1];
    useEffect(function () {
        if (!usePrefetchAccessTokenEnabled) {
            return;
        }
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var accessToken, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getFreshAccessToken(componentContext, userEntitlements)];
                        case 1:
                            accessToken = _a.sent();
                            setPrefetchedToken(accessToken);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            logError({
                                eventName: 'Prefetch_Token_Failure',
                                debugInfo: (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || 'token prefetch failed',
                            });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        fetchData();
    }, [componentContext, usePrefetchAccessTokenEnabled, userEntitlements]);
    return prefetchedToken;
};
//# sourceMappingURL=usePrefetchAccessToken.js.map